module.exports = __webpack_public_path__ + "static/BAO2-2e92a5127be89110e286766aafe1f8aa.png";